import { EmailSenderLayout } from "../EmailSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { EmailSenderEntities } from "../EmailSenderEntities";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";

export interface IProviderPageProps extends NSARouterMakerResult, EmailSenderRouterProps { }

function ProviderViewPage(props: IProviderPageProps)
{
	return (
		<EmailSenderLayout {...props}
			action={{
				description: "This section displays detailed information about a selected Email provider."
			}}
			pages={{
				entity: EmailSenderEntities.provider(props),
				view: {}
			}}
		>
			<></>
		</EmailSenderLayout>
	);
}

export default ProviderViewPage;